define((require) => {
    "use strict";

    var ViewController = require("editor/util/ViewController"),
        EditorEvents   = require("shared/services/EditorEvents");

    return ViewController.extend({
        onViewToggleEmailMode: function() {
            this.model.set("emailModeEnabled", !this.model.get("emailModeEnabled"));
        },

        onViewToggleComments: function() {
            this.model.set("showComments", !this.model.get("showComments"));
        },

        onViewAddComment: function() {
            this.view.hide();

            this.model.get("commentsRenderer").addComment();

            var experience = this.options.experience,
                eventProperties = {
                    experienceId: experience.get("id"),
                    experienceVersion: experience.get("version"),
                    experiencePushedVersion: experience.get("pushedVersion"),
                    triggerOrigin: "EditorMoreMenu"
                };
            EditorEvents.trigger(EditorEvents.constants.CREATE_COMMENT_THREAD, eventProperties);
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/editor/editorMoreMenu/EditorMoreMenuViewController.js